/**
 * Límites duros del motor (05-arquitectura-tecnica.md y 08-seguridad-privacidad.md):
 * tamaño, cantidad y tiempo. Se aplican ANTES/DURANTE de procesar el dataset
 * para evitar que un archivo hostil o desproporcionado bloquee el hilo
 * principal o genere una exportación fuera de control.
 */
export const LIMITS = {
  /** Número máximo de filas (registros) que el motor procesa en una ejecución. */
  maxRecords: 500,
  /** Número máximo de columnas (campos) que el motor perfila y enmascara. */
  maxFields: 60,
  /** Longitud máxima de una celda de texto antes de truncarla en el perfilado. */
  maxCellLength: 2000,
  /** Nº máximo de valores de muestra usados para detectar el tipo/categoría de un campo. */
  maxSampleSize: 25,
  /** Máximo de hallazgos visibles, alineado con contracts/output.schema.json (maxItems). */
  maxFindings: 1000,
  /** Presupuesto de tiempo de ejecución del motor antes de abortar (ms). */
  maxRunDurationMs: 5000,
  /** Tamaño máximo de un archivo exportado en bytes (5 MB, según 06-modelo-datos.md). */
  maxExportBytes: 5 * 1024 * 1024,
  /** Tamaño máximo de un archivo local cargado por el visitante (05-arquitectura-tecnica.md). */
  maxUploadBytes: 10 * 1024 * 1024,
  /** Filas mostradas en la vista previa/diff antes de exportar. */
  maxDiffPreviewRows: 20,
} as const;
